import { Sound } from './Sound';
import { AudioDevice } from './AudioDevice';
import { AudioResource } from './AudioResource';

export class SoundFactory {
  private _audioDevice: AudioDevice;

  constructor(audioDevice: AudioDevice) {
    this._audioDevice = audioDevice;
  }

  createSound(resource: AudioResource): Sound {
    return new Sound(this._audioDevice, resource);
  }
}

export enum SoundState {
  Playing,
  Stopped,
  Paused,
  Destroyed,
}
